import * as React from 'react';
import { useState } from 'react';
import { Modal, Typography, Stack, Button, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRight from '../icons/ArrowRight';
import LogoIsaac from '@/assets/images/logoIsaac.png';
import LogoSophia from '@/assets/images/logoSophia.png';
import LogoSponte from '@/assets/images/sponte.png';

type PropsType = {
  open: boolean;
  handleClose: () => void;
};

const ImportCountDefault: React.FC<PropsType> = ({
  open,
  handleClose,
}) => {
  const [stepFirstAccess, setStepFirstAccess] = useState(9);


  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: stepFirstAccess === 9 ? '750px' : '517px',
    width: '100%',
    bgcolor: '#fff',
    borderRadius: '20px',
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          px={'20px'}
          py={'10px'}
          style={{ background: '#93DC3F', borderRadius: '20px 20px 0 0', boxShadow: '0px 4px 4px 0px #00000040' }}
          >
            <Typography 
              style={{
                fontWeight: 700,
                textTransform: 'capitalize'
              }}
              color={'#231F20'} variant="h1"
            >
            Importar contas
            </Typography>
            <CloseIcon sx={{cursor: 'pointer'}} onClick={handleClose}/>
          </Box>
          <Stack sx={{ p: '20px 30px 50px 30px' }} justifyContent={'center'} alignItems={'center'}>
            <Box>
              <Typography sx={{fontWeight: 600}}>Selecione e faça a integração com um sistema de inadimplência zero.</Typography>
              <Typography mt={'15px'} mb={'30px'} color={'#808080'} sx={{maxWidth: '520px', fontStyle: 'italic'}}>Sistemas focados em trazer recomendações e direcionamentos de como zerar a inadimplência de empresas</Typography>

            </Box>
            <Box>
                <Box sx={{ display: 'flex' }}>
                  <Stack alignItems={'center'}>
                    <Stack flexDirection={'row'} color={'black'} gap={'10px'} sx={{ display: 'flex', ml: '30px', height: '190px' }}>
                      <Stack
                        sx={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)' }}
                        alignItems={'center'}
                        height={'100%'}
                        border={'1px solid rgba(224, 221, 221, 1)'}
                        borderRadius={'8px'}
                        justifyContent={'space-between'}
                        gap={'25%'}
                      >
                        <div style={{padding: '40px 40px 0 40px', height: '50%'}}>
                          <img style={{ width: '85px' }} src={LogoIsaac} alt="" />
                        </div>
                        <Stack alignItems={'center'} sx={{ flex: '1', width: '100%'}}>
                          <div style={{width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                            <Typography sx={{ fontWeight: '700', display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>Isaac</Typography>
                            <Typography sx={{ border: '0.5px solid #E0DDDD', width: '100%' }}></Typography>
                            <div style={{
                              height: '100%',
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'end',
                              padding: '3px 10px 6px'
                            }}>
                              <Button
                                sx={{ width: '100%', borderRadius: '24px', fontSize: '12px' }}
                                variant="contained"
                                style={{
                                  background: '#15AB51',
                                  textTransform: 'capitalize',
                                  height: '24px',
                                  padding: '0 !important'
                                }}
                              >
                                Integrar
                              </Button>
                            </div>
                          </div>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)' }}
                        alignItems={'center'}
                        height={'100%'}
                        border={'1px solid rgba(224, 221, 221, 1)'}
                        borderRadius={'8px'}
                        justifyContent={'space-between'}
                        gap={"25%"}
                      >
                        <div style={{padding: '40px 40px 0 40px', height:'50%'}}>
                          <img style={{ width: '85px' }} src={LogoSophia} alt="" />
                        </div>
                        <Stack alignItems={'center'} sx={{ flex: '1', width: '100%'}}>
                          <div style={{width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                            <Typography sx={{ fontWeight: '700', display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>Sophia</Typography>
                            <Typography sx={{ border: '0.5px solid #E0DDDD', width: '100%' }}></Typography>
                            <div style={{
                              height: '100%',
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'end',
                              padding: '3px 10px 6px'
                            }}>
                              <Button
                                sx={{ width: '100%', borderRadius: '24px', fontSize: '12px' }}
                                variant="contained"
                                style={{
                                  background: '#15AB51',
                                  textTransform: 'capitalize',
                                  height: '24px',
                                  padding: '0 !important'
                                }}
                              >
                                Integrar
                              </Button>
                            </div>
                          </div>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)' }}
                        alignItems={'center'}
                        height={'100%'}
                        border={'1px solid rgba(224, 221, 221, 1)'}
                        borderRadius={'8px'}
                        justifyContent={'space-between'}
                        gap={'25%'}
                      >
                        <div style={{padding: '40px 40px 0 40px', height:"50%"}}>
                          <img style={{ width: '85px' }} src={LogoSponte} alt="" />
                        </div>
                        <Stack alignItems={'center'} sx={{ flex: '1', width: '100%'}}>
                          <div style={{width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                            <Typography sx={{ fontWeight: '700', display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>Sponte</Typography>
                            <Typography sx={{ border: '0.5px solid #E0DDDD', width: '100%' }}></Typography>
                            <div style={{
                              height: '100%',
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'end',
                              padding: '3px 10px 6px'
                            }}>
                              <Button
                                sx={{ width: '100%', borderRadius: '24px', fontSize: '12px' }}
                                variant="contained"
                                style={{
                                  background: '#15AB51',
                                  textTransform: 'capitalize',
                                  height: '24px',
                                  padding: '0 !important'
                                }}
                              >
                                Integrar
                              </Button>
                            </div>
                          </div>
                        </Stack>
                      </Stack>
                    </Stack>

                  
                  </Stack>
                </Box>
          
            </Box>
            {stepFirstAccess !== 9 && (
              <Button
                sx={{ maxWidth: '200px', p: '15.5px 50px', borderRadius: '24px', fontSize: '14px', mt: '60px' }}
                variant="contained"
                onClick={() => setStepFirstAccess(stepFirstAccess + 1)}
              >
                Continue
                <ArrowRight style={{ marginLeft: '10px' }} />
              </Button>
             )} 
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default ImportCountDefault;
